export default __webpack_public_path__ + "static/media/edit.f7068f49.svg";